import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { UserService } from "../../../domain/user-service";
import { Channel } from "../../../domain/channel";

@Component({
  selector: "report-window",
  templateUrl: "./report-window.component.html",
  styleUrls: ["./report-window.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportWindowComponent implements OnInit {
  isDragged = false;

  private lastPositionX: number;
  private lastPositionY: number;

  translateX: number = 0;
  translateY: number = 0;

  @Output()
  clickOnCloseBtn: EventEmitter<boolean> = new EventEmitter();

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {}

  onMouseDown(event) {
    this.isDragged = true;
    this.lastPositionX = event.clientX;
    this.lastPositionY = event.clientY;
    this.changeDetectorRef.markForCheck();
  }

  onMouseMove(event) {
    if (!this.isDragged) return;

    let diffX = event.clientX - this.lastPositionX;
    let diffY = event.clientY - this.lastPositionY;
    this.lastPositionX = event.clientX;
    this.lastPositionY = event.clientY;

    this.translateX += diffX;
    this.translateY += diffY;
    this.changeDetectorRef.markForCheck();
  }

  onMouseUp() {
    this.isDragged = false;
    this.changeDetectorRef.markForCheck();
  }

  close() {
    this.clickOnCloseBtn.emit();
    this.changeDetectorRef.markForCheck();
  }
}
